import axios from '../utils/axios'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'

export type TokenResponse = {
  accessToken: {
    token: string
    issuedAt: number
    expiryAt: number
  }
  idToken: {
    token: string
    issuedAt: number
    expiryAt: number
  }
  refreshToken: string
}

export type User = {
  name: string
  email: string
  tokens: TokenResponse
  roles?: 'SUPERADMIN' | 'ADMIN' | 'EMPLOYEE'
  user_type: 'COllAB_USER' | 'BUSINESS_USER' | 'NON_BUSINESS_USER' | ''
  businessUser: boolean
  collabUser: boolean
  isSSO?: boolean
  authenticated?: boolean
  isVerifyOtp?: boolean
  authorisedApp?: string[]
}
export type UserObjectType = AxiosResponse<{
  data: User
}>

const SIGN_IN_URL = process.env.REACT_APP_SSO_SIGNIN as string

async function ssoSignIN(
  username: string,
  password: string,
  isSSO: boolean,
  token?: string
): Promise<UserObjectType> {
  try {
    const config: AxiosRequestConfig = {
      method: 'POST',
      url: SIGN_IN_URL,
      data: isSSO ? { token, username } : { username, password },
      headers: isSSO ? { 'x-source': 'sso' } : undefined,
    }

    const signInUserResponse = await axios(config)
    return signInUserResponse
    // eslint-disable-next-line
  } catch (error: any) {
    throw error?.response ?? error
  }
}

export { ssoSignIN }
